export const TOOLPAD_LATEST_CREATED_APP_KEY = 'toolpad-latest-app';
export type StoredLatestCreatedApp = { appId: string; appName: string } | null;
